import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShapeLineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"shape_line"}/>
}
